export const COMPARTMENTLIST_REQUEST = "COMPARTMENTLIST_REQUEST";
export const COMPARTMENTLIST_SUCCESS = "COMPARTMENTLIST_SUCCESS";
export const COMPARTMENTLIST_ERROR = "COMPARTMENTLIST_ERROR";
export const COMPARTMENTLIST_params = {
    key: process.env.VUE_APP_API_KEY,
    connector: 'ILTTripCompartmentWeight',
    size: 1000,
    filter: []
};